import { ErrorMessage } from "./alerts/errorMessage";
import { SuccessMessage } from "./alerts/successMessage";
import { ButtonOption } from "./buttonOption/buttonOption";
import { ButtonTerminarFirmado } from "./buttonOption/buttonTerminarFirmado";
import { FirmaElectronica as FirmaElectronicaHOC } from "./firmaElectronica";
import { Firmantes } from "./firmantes/firmantes";
import { InputCert } from "./inputCert/inputCert";
import { InputKey } from "./inputKey/inputKey";
import { InputPassword } from "./inputPassword/inputPassword";
import { LinkSaveCertificado } from "./saveCertificados/linkSaveCertificado";
import { TipoFirmante } from "./tipoFirmante/tipoFirmante";

export { ErrorMessage } from "./alerts/errorMessage";
export { SuccessMessage } from "./alerts/successMessage";
export { ButtonOption } from "./buttonOption/buttonOption";
export { FirmaElectronica } from "./firmaElectronica";
export { Firmantes } from "./firmantes/firmantes";
export { InputCert } from "./inputCert/inputCert";
export { InputKey } from "./inputKey/inputKey";
export { TipoFirmante } from "./tipoFirmante/tipoFirmante";
export { LinkSaveCertificado } from "./saveCertificados/linkSaveCertificado";
export { ButtonTerminarFirmado } from "./buttonOption/buttonTerminarFirmado";

export const FirmaElectronicaComponent = Object.assign(FirmaElectronicaHOC, {
  Cer: InputCert,
  Key: InputKey,
  Firmante: TipoFirmante,
  Option: ButtonOption,
  Password: InputPassword,
  SuccessMessages: SuccessMessage,
  ErrorMessage: ErrorMessage,
  LinkCertKey: LinkSaveCertificado,
  TerminarFirmado: ButtonTerminarFirmado,
  Firmantes: Firmantes,
});
